import { selectedProcess } from '@/consts/auth';
import { SelectedProcess } from '@/types/api/authApi';

interface ResolveLoginTelParams {
  selectedProcess: SelectedProcess;
  phoneNumber: string;
  previousPhoneNumber?: string;
  storedLoginTel: string | null;
}

export const resolveLoginTelAfterPinSuccess = ({
  selectedProcess: process,
  phoneNumber,
  previousPhoneNumber,
  storedLoginTel,
}: ResolveLoginTelParams): string | null => {
  if (process === selectedProcess.login) return phoneNumber;

  const isChangingLoginTel =
    process === selectedProcess.change &&
    storedLoginTel !== null &&
    storedLoginTel === previousPhoneNumber;

  return isChangingLoginTel ? phoneNumber : storedLoginTel;
};
